import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {ConstructListComponent} from './construct-list.component';
import {ConstructListRepository} from './repositories/construct-list.repository';
import {ConstructListService} from './services/construct-list.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    ConstructListComponent,
  ],
  providers: [
    ConstructListService,
    ConstructListRepository,
  ],
  exports: [
    ConstructListComponent,
  ],
})
export class ConstructListModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/construct-list/construct-list.module.ts